<template>
  <div class="mt16">
    <QS-h4-title title="司机警示金" />
    <el-row>
      <el-col :span="8">
        <el-form label-width="auto" :model="driverWarningPayData">
      <el-form-item  label="类型">
        <span class="ml30">应收金额（元）</span>
      </el-form-item>
      <el-form-item label="超保费" v-if="type===2">
        <el-input class="w200 ml30" v-model="driverWarningPayData.exceedAmount" @input="(val)=>priceChange(val,'exceedAmount')"></el-input>
      </el-form-item>
      <el-form-item label="保险上浮费" v-if="type!==2">
        <el-input class="w200 ml30"  v-model="driverWarningPayData.floatAmount" @input="(val)=>priceChange(val,'floatAmount')"></el-input>
      </el-form-item>
      <el-form-item label="车辆加速择旧费" v-if="type!==2">
        <el-input class="w200 ml30"  v-model="driverWarningPayData.depreciationAmount" @input="(val)=>priceChange(val,'depreciationAmount')"></el-input>
      </el-form-item>
    </el-form>
      </el-col>
    </el-row>
  </div>

</template>
<script>
import { limitMoreZero } from '@/utils/validate'

export default {
  name: 'editDriverWarningPay',
  props: ['driverWarningPayData', 'type'],
  methods: {
    // 监听金额变化
    priceChange(val, key) {
      limitMoreZero(val, (value) => {
        this.$set(this.driverWarningPayData, key, value)
      }, 9)
    },
  },
}
</script>

<style lang="scss" scoped>
.w200{
  width:200px
}
.ml30{
  margin-left:30px
}
</style>
